var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);
// Dummy class necessary to give `babel-transform-custom-element-classes`
// something to operate on, producing es5-compatible code.
var _HTMLElement = function (_CustomElement2) {
  inherits(_HTMLElement, _CustomElement2);

  function _HTMLElement() {
    classCallCheck(this, _HTMLElement);
    return possibleConstructorReturn(this, (_HTMLElement.__proto__ || Object.getPrototypeOf(_HTMLElement)).apply(this, arguments));
  }

  return _HTMLElement;
}(_CustomElement);

var withFormValidation = function withFormValidation() {
  var Base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _HTMLElement;
  return function (_Base) {
    inherits(_class2, _Base);

    function _class2() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this._validators = [], _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(_class2, [{
      key: 'connectedCallback',
      value: function connectedCallback() {
        get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'connectedCallback', this) && get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'connectedCallback', this).call(this);

        if (!this._input) {
          throw new Error('[withFormValidation] `_input` property is not defined in the constructor');
        }

        this.setAttribute('aria-invalid', !this.validity.valid);
      }
    }, {
      key: 'checkValidity',
      value: function checkValidity() {
        var _this2 = this;

        this._input.checkValidity();

        // Clear any existing custom errors before running validation.
        this.setCustomValidity('');
        this._validators.every(function (fn) {
          return fn(_this2);
        });

        var valid = this.validity.valid;
        this.classList.add('upd-validated');
        this.setAttribute('aria-invalid', !valid);

        this.dispatchEvent(new CustomEvent('updvalidation', {
          bubbles: true,
          composed: true
        }));
        // TODO: revisit this flag as it is only needed for upd-input
        // https://app.clubhouse.io/updater/story/11465/
        this._hasBeenValidatedAlready = true;
        return valid;
      }
    }, {
      key: 'setCustomValidity',
      value: function setCustomValidity(message) {
        this._input.setCustomValidity(message);
      }
    }, {
      key: 'addValidator',
      value: function addValidator(validatorFn) {
        this._validators.push(validatorFn);
      }
    }, {
      key: 'removeValidator',
      value: function removeValidator(validatorFn) {
        this._validators = this._validators.filter(function (fn) {
          return fn !== validatorFn;
        });
      }
    }, {
      key: 'validators',
      set: function set$$1(validators) {
        this._validators = this._validators.concat(validators);
      }
    }, {
      key: 'validity',
      get: function get$$1() {
        return this._input.validity;
      }
    }, {
      key: 'validationMessage',
      get: function get$$1() {
        return this._input.validationMessage;
      }
    }, {
      key: 'willValidate',
      get: function get$$1() {
        return this._input.willValidate;
      }
    }]);
    return _class2;
  }(Base);
};

export { withFormValidation };
